var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#E3DBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5208 21.665C28.7764 21.665 21.6875 28.7536 21.6875 37.4984C21.6875 46.2431 28.7764 53.3317 37.5208 53.3317C46.2653 53.3317 53.3542 46.2431 53.3542 37.4984C53.3542 28.7536 46.2653 21.665 37.5208 21.665ZM37.5208 27.9984C38.3953 27.9984 39.1042 28.7077 39.1042 29.5817V36.8049L43.4089 41.11C44.0272 41.729 44.0272 42.7677 43.4089 43.3868C42.7905 44.0043 41.7512 44.0043 41.1327 43.3868L36.3827 38.6368C36.0859 38.3391 35.9375 37.918 35.9375 37.4984V29.5817C35.9375 28.7077 36.6464 27.9984 37.5208 27.9984Z",
    fill: "#927BF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRound);
export default __webpack_public_path__ + "static/media/clock-round.d47a04b29d8b597d3523a798529ef71a.svg";
export { ForwardRef as ReactComponent };